import http from "./httpService";
import urlConstant from "../constants/url-constants";

export async function RegisterServiceCenterRequest(CustomerTitle, CustomerPhone, RequestText, RequestType, RequestTypeId, ProvinceId, ProvinceText, HavayarProduction, CaptchaRef) {
    const { data: result } = await http.post(urlConstant.getRegisterServiceRequestEndpoint(), {
        CustomerTitle,
        CustomerPhone,
        RequestText,
        RequestType,
        RequestTypeId,
        ProvinceId,
        ProvinceText,
        HavayarProduction,
        CaptchaRef
    }, http.getPublicConfig());
    return result;
}

export default {
    RegisterServiceCenterRequest
};